<template>
  <div id="home">
    <div class="filter-tab">
      <div class="search-box btn">
        <i class="fas fa-search color-change"></i>
        <input id="country" type="text" placeholder="search for a country..." class="color-change" v-model="country">
      </div>
      <div class="select-continent">
        <select name="continent" id="continent" v-model="region">
          <option value="Africa">Africa</option>
          <option value="Asia">Asia</option>
          <option value="Americas">America</option>
          <option value="Europe">Europe</option>
          <option value="Oceania">Oceania</option>
        </select>
      </div>
    </div>
    <div class="rest-countries">
      <div class="rest-countries-wrapper">
        <div class="country btn" v-for="country in filterByContinent">
          <router-link :to="'/' + country.name">
            <div class="flag-wrapper">
              <img :src="country.flag" alt="country flag">
            </div>
            <div class="country-details">
              <h2 class="color-change name">{{ country.name }}</h2>
              <p class="color-change pop"><span class="bold">Population: </span>{{ country.population }}</p>
              <p class="color-change reg"><span class="bold">Region: </span>{{ country.region }}</p>
              <p class="color-change cap"><span class="bold">Capital: </span>{{ country.capital }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      countries: [],
      toggleVisibility: false,
      region: 'Africa',
      country: ''
    }
  },
  created() {
    fetch('https://restcountries.eu/rest/v2/all').then(res => res.json()).then(data => {
      this.countries = data;
    });
  },
  computed: {
    filterByContinent() {
      let filteredCountries = this.countries.filter(obj => obj.region == this.region).filter(obj => obj.name.toLowerCase().match(this.country.toLowerCase()));
      return filteredCountries;
    }
  }
}
</script>

<style scoped>

#home {
    padding: 3rem 0 5rem;
    width: 100vw;
    height: 100%;
}

.filter-tab {
  width: 90%;
  margin: 0 auto 4rem;
  display: flex;
  flex-direction: column;
}

.search-box {
  width: 100%;
  height: 6rem;
  padding: 2rem 1.5rem;
  border-radius: .5rem;
  box-shadow: 0 0 .5rem rgba(0,0,0,.2);
  margin-bottom: 4rem;
  position: relative;
}

.fa-search {
  margin-right: 2rem;
  font-size: 1.8rem;
}

#country {
  height: 100%;
  width: 80%;
  position: absolute;
  left: 15%;
  top: 0;
  background: none;
  border: none;
  outline: none;
}

.select-continent {
  width: 50%;
  border-radius: 1rem;
  position: relative;
  z-index: 1;
}

#continent {
  width: 100%;
  height: 100%;
  padding: 2rem 1.5rem;
  box-shadow: 0 0 .5rem rgba(0,0,0,.2);
  border: none;
  outline: none;
  border-radius: .5rem;
  cursor: pointer;
}

.rest-countries {
  width: 90%;
  margin: 0 auto;
}

.rest-countries-wrapper,
.country {
  width: 100%;
}


.rest-countries-wrapper {
  display: flex;
  flex-direction: column;
}

.country {
  border-radius: 1rem;
  box-shadow: 0 0 1rem rgba(0,0,0,.5);
  overflow: hidden;
  margin-bottom: 6rem;
}

.flag-wrapper {
  width: 100%;
  min-height: 20rem;
  margin-bottom: 2rem;
}

.flag-wrapper img {
  width: 100%;
  height: 100%;
}

.country-details {
  width: 85%;
  margin: 0 auto;
}

.name {
  margin-bottom: 2rem;
}

span.bold {
  font-weight: 800;
}

.country-details p {
  margin-bottom: 1.5rem;
}

.country-details p:nth-of-type(3) {
  margin-bottom: 3rem;
}

/* MEDAI QUERIES */
@media (min-width: 768px) {
  .name {
    font-size: 2.3rem;
  }

  .filter-tab {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .search-box {
    width: 60%;
  }

  .select-continent {
    width: 15%;
  }

  .fa-search {
    margin-right: 2rem;
  }

  #country {
    left: 12%;
  }
}

@media (min-width: 900px) {
  .rest-countries-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 3rem;
  }
}

@media (min-width: 1300px) {
  .rest-countries-wrapper {
    display: grid;
    grid-template-columns: repeat(4,1fr);
    grid-gap: 3rem;
  }

  .search-box {
    width: 35%;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/home.vue